// ---- Shipping contact rules (frontend mirror, display + instant feedback) ---
// The carrier needs a way to reach the recipient: email + Taiwan mobile for
// every order, plus a delivery time slot for 黑貓宅配 (T-cat).
// Mirrors backend/utils/shippingContact.js (the source of truth) for instant form
// feedback. POST /api/orders re-validates on the server, so a tampered client
// still can't skip the fields.

export const DELIVERY_TIME_SLOTS = {
  before12: '12:00 前',
  '12to17': '12:00–17:00',
  '17to20': '17:00–20:00',
};

// Carriers that require a delivery time slot
export const CARRIERS_WITH_TIME_SLOT = ['tcat'];

// LINE Login placeholder emails can't receive mail, so they don't count.
const PLACEHOLDER_EMAIL = /@users\.line\.local$/i;
const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

/** "0912-345-678", "0912 345 678", "+886 912 345 678" -> "0912345678" */
export function normalizeMobile(raw) {
  let digits = String(raw ?? '').replace(/[\s\-()]/g, '');
  if (digits.startsWith('+886')) digits = '0' + digits.slice(4);
  else if (digits.startsWith('886') && digits.length === 12) digits = '0' + digits.slice(3);
  return digits;
}

export function normalizeEmail(raw) {
  return String(raw ?? '').trim().toLowerCase();
}

/**
 * Returns { email?, mobile?, deliveryTime? } — one zh-TW message per bad field.
 * An empty object means everything is valid.
 */
export function validateShippingContact({ email, mobile, shippingMethodId, deliveryTime }) {
  const errors = {};

  const e = normalizeEmail(email);
  if (!e) errors.email = '請填寫 Email';
  else if (!EMAIL.test(e) || PLACEHOLDER_EMAIL.test(e)) errors.email = 'Email 格式不正確';

  const m = normalizeMobile(mobile);
  if (!m) errors.mobile = '請填寫手機號碼';
  else if (!/^09\d{8}$/.test(m)) errors.mobile = '手機號碼格式不正確（例：0912345678）';

  if (CARRIERS_WITH_TIME_SLOT.includes(shippingMethodId)) {
    if (!deliveryTime) errors.deliveryTime = '請選擇黑貓宅配的配達時段';
    else if (!Object.prototype.hasOwnProperty.call(DELIVERY_TIME_SLOTS, deliveryTime)) errors.deliveryTime = '配達時段不正確';
  }

  return errors;
}
